import { render, staticRenderFns } from "./HttpReq.vue?vue&type=template&id=f44db54e&scoped=true"
import script from "./HttpReq.vue?vue&type=script&lang=js"
export * from "./HttpReq.vue?vue&type=script&lang=js"
import style0 from "./HttpReq.vue?vue&type=style&index=0&id=f44db54e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44db54e",
  null
  
)

export default component.exports